<interview-wrapper [title]="'interviews.Begin Title' | translate">
    <div step-content>
        <div>{{'interviews.Begin Subtitle' | translate : { number_of_questions: questionTotal, interview_length: interviewLength } }}</div>
        <br/>
        <ol class="ordered-list">
            <li class="list-item">
                {{'interviews.Begin Step 1' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Begin Step 2' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Begin Step 3' | translate}}
            </li>
            <li class="list-item">
                {{'interviews.Begin Step 4' | translate}}
            </li>
        </ol>
    </div>
    <div step-actions>
        <button type="button" [routerLink]="['../create']" class="btn btn_primary">
            {{"interviews.Let's Begin" | translate}}
        </button>
    </div>
</interview-wrapper>
